// @workflow platform.viewer
/** Id helpers shared by the viewer adapter. No imports, so node --test can load it directly. */

/** Ids from the store, the server and the URL differ in type (42 vs '42'); both sides must be set. */
export const sameId = (a, b) => a !== null && a !== undefined && b !== null && b !== undefined && String(a) === String(b);

/** A tag's element ids: the dbIds of its children. */
export const childDbIds = (tag) => (tag && Array.isArray(tag.children) ? tag.children.map((child) => child && child.dbId) : []);
